import { render, staticRenderFns } from "./ResultCustom.vue?vue&type=template&id=03b09956&scoped=true&"
import script from "./ResultCustom.vue?vue&type=script&lang=js&"
export * from "./ResultCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b09956",
  null
  
)

export default component.exports